import { render, staticRenderFns } from "./N8n.vue?vue&type=template&id=be20f6a8"
import script from "./N8n.vue?vue&type=script&lang=ts"
export * from "./N8n.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports